import appLocaleData from 'react-intl/locale-data/ar';
import saMessages from '../locales/ar_SA';

interface LanguageData {
  messages: Record<string, any>;
  locale: string;
  data: any;
}

const saLang: LanguageData = {
  messages: {
    ...saMessages,
  },
  locale: 'ar-SA',
  data: appLocaleData,
};

export default saLang;
